import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import pSifreDegistir from '../../../../api/models/pSifreDegistir';
import rCore from '../../../../api/models/rCore';

export default ApiBaseReducer<pSifreDegistir, IInputDataStateModel<pSifreDegistir, rCore>, rCore>(
  ActionSubTypes.API_SIFREDEGISTIR,
  DefaultInputDataStateModel<pSifreDegistir, rCore>()
);
